.container {
  width: 100%;
  cursor: default;

  &:hover {
    background: initial;
  }

  .user {
    .paragraph {
      :global .ant-skeleton-paragraph {
        & li {
          border-radius: 4px;
          margin-top: 8px;
          width: 250px;

          &:first-child {
            margin-top: 2px;
          }

          &:nth-child(2) {
            width: 170px;
          }

          &:last-child {
            height: 16px;
            width: 120px !important;
          }
        }
      }
    }
  }
}
